// extracted by mini-css-extract-plugin
export default {"linkButton":"linkButton__dT8Ki","block":"block__q4FG6","loading":"loading__yjkat","disabled":"disabled__LUAct"};